/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Section from '../components/Section'
import FairTradeLogos from '../assets/images/fair-trade-logos.png'

function SellerExpectations() {
	return (
		<div className='main-container'>
			<Section className='height-auto'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-sm-8 col-md-7 text-center'>
							<h2>Seller Expectations</h2>
						</div>
					</div>
				</div>
			</Section>

			<Section id='seller-expectations__section'>
				<div className='col-12 col-md-10 offset-md-1 offset-0'>
					<p>
						The expectations we have of sellers on The Etho are
						outlined below. Because these expectations are part of
						our Terms of Use and all of its related policies
						(“Terms”), they constitute an agreement between you, the
						seller, and The Etho, Inc. ("The Etho"), that you will
						adhere to all of The Etho's policies and rules. By
						operating a shop in our online marketplace, or by
						navigating The Etho's website, you are agreeing to abide
						by these Terms. These policies (and what we expect of
						sellers on The Etho in abiding by them), are designed to
						help and protect sellers and customers active in our
						marketplace.
					</p>
					<h3 className=''>
						At The Etho, we expect our Sellers to do the following
						things:
					</h3>
					<ol>
						<li>
							<p>
								Respond to questions from customers or potential
								buyers within 48 hours
							</p>
						</li>
						<li>
							<p>
								Communicate appropriately with all The Etho
								users. (As we explain in our Terms of Use, which
								includes (among others), our
								Anti-Discrimination, Community Guidelines, and
								Online Communications Policies, The Etho expects
								only polite and appropriate communication
								between customers and sellers, without
								exception.)
							</p>
							<ol>
								<li>
									<p>
										If you experience any inappropriate
										communication (or, any type of
										harassment) please report the activity
										to us immediately.
									</p>
								</li>
								<li>
									<p>
										If The Etho determines that you have
										initiated inappropriate communication of
										any kind, you will be removed from the
										site permanently.
									</p>
								</li>
							</ol>
						</li>
						<li>
							<p>
								Send purchased items to customers as they are
								shown in The Etho’s marketplace (We understand
								that some products will have slight variations
								if they’re handmade, or are made-to-order custom
								pieces, and so will customers.)
							</p>
							<ol>
								<li>
									<p>
										No products can be previously worn or
										used (i.e., you are not allowed to sell
										used clothing or second hand items,
										excluding the re-use of materials in
										making new products).
									</p>
								</li>
								<li>
									<p>
										Sellers must also describe, in a
										detailed and accurate way, everything
										that goes into creating all of the
										products for sale in your shop. This
										“about” area on an item’s page, and/or
										on your shop’s homepage, doesn’t need to
										be lengthy –– just detailed enough for
										customers to understand the materials,
										people, and process behind the things
										they’re buying.
									</p>
								</li>
							</ol>
						</li>
						<li>
							<p>
								Ship ordered item(s) within 48 hours of purchase
							</p>
							<ol>
								<li>
									<p>
										Unless products are custom made-to-order
										pieces, then sellers are required to
										specify a shipping time frame for
										customer(s) based on the location of
										their shipping address.
									</p>
								</li>
								<li>
									<p>
										All sellers on The Etho are required to
										purchase shipping insurance, the cost of
										which can be factored into to your sale
										price (Insurance is inexpensive, but
										also important for customer satisfaction
										and security.)
									</p>
								</li>
							</ol>
						</li>
					</ol>
					<h3 className=''>
						Applicable fees for sellers &amp; The Etho's pricing
						structure:
					</h3>
					<ol>
						<li>
							<p>
								The Etho’s “shop fee” –– the cost of operating
								your business in our online marketplace –– is
								15% of an item’s listed sale price
							</p>
							<ol>
								<li>
									<p>
										This means that 15% of the listed price
										of every item is taken from sellers
										every time an item is sold on The Etho.
									</p>
								</li>
							</ol>
						</li>
						<li>
							<p>
								Unlike a set dollar amount per transaction ––
								which can be burdensome for sellers, especially
								with cheaper items –– this percentage can be
								easily factored into the sale price of each item
								sold in your shop
							</p>
						</li>
						<li>
							<p>
								The 15% shop fee is collected by The Etho when
								the sale revenue from that item is released to
								you, at the time of a product’s shipment
							</p>
						</li>
					</ol>
					<h3 className=''>What you can expect from us:</h3>
					<ol>
						<li>
							<p>
								The promotion of and adherence to our Core
								Ethical Trade Principles and our Mission
							</p>
						</li>
						<li>
							<p>
								The release of your shop’s sale revenue upon the
								shipment of each sold product according to our
								pricing structure
							</p>
						</li>
						<li>
							<p>
								Transparency in The Etho's fee processing and
								all related payment activities
							</p>
						</li>
						<li>
							<p>
								Prompt communication from The Etho’s
								seller-support staff
							</p>
						</li>
						<li>
							<p>Business support and shop maintenance:</p>
							<ol>
								<li>
									<p>
										Shop set-up assistance (e.g., getting
										and using high quality photographs,
										configuring display settings, etc.)
									</p>
								</li>
								<li>
									<p>
										Instant and accurate records of all
										transactions in your shop
									</p>
								</li>
								<li>
									<p>
										Easy-to-use tools for communication with
										customers
									</p>
								</li>
								<li>
									<p>
										Shop rating and customer-review
										functions
									</p>
								</li>
								<li>
									<p>
										Responsive troubleshooting support for
										shop-related technical problems,
										content-translation issues, and other
										listing or sale-related problems
									</p>
								</li>
							</ol>
						</li>
					</ol>
					<h3 className=''>What you can sell on The Etho</h3>
					<p>
						Customers come to The Etho to buy products that adhere
						to Fair Trade standards of production, and that directly
						benefit sellers and stakeholders in producers’ local
						communities. Everything listed for sale in our virtual
						marketplace must meet the Fair Trade standards outlined
						in our 7 Core Principles of Ethical Production, and must
						comply with our origin-traceability requirements and our
						Terms of Use. This means that The Etho, and your shop’s
						customers, must have easy access to relevant information
						about where your products (and their materials) were
						made, who made them, and how they were produced.
					</p>
					<ol>
						<li>
							<p>
								Sellers can sell ethically produced clothing,
								accessories, jewelry, home decor, made-to-order
								custom pieces of art, agricultural commodities,
								toys, collectibles, and other artisan crafts (or
								related products)
							</p>
							<ol>
								<li>
									<p>
										What you are prohibited from selling on
										The Etho is detailed below, and in more
										detail in our Prohibited Items Policy.
									</p>
								</li>
							</ol>
						</li>
					</ol>
					<h3 className=''>What can't be sold on The Etho</h3>
					<ol>
						<li>
							<p>
								Even if they otherwise meet our Fair Trade
								criteria, services and items that violate our
								Prohibited Items Policy (including other
								policies not listed here that collectively help
								make up our Terms of Use) are not allowed to be
								sold on The Etho
							</p>
							<ol>
								<li>
									<p>
										Keep in mind that members may flag
										listings that appear to violate our
										policies for our review.
									</p>
								</li>
								<li>
									<p>
										The Etho may remove any listings that
										violate our policies, or may withhold
										funds earned from selling prohibited
										items.
									</p>
								</li>
							</ol>
						</li>
						<li>
							<p>
								For easy reference, the following items may not
								be sold on The Etho:
							</p>
							<ol>
								<li>
									<p>Guns, knives, or other weapons</p>
								</li>
								<li>
									<p>
										Drugs, tobacco, alcohol, and drug
										paraphernalia of any kind
									</p>
								</li>
								<li>
									<p>
										Explosives or combustibles (fireworks,
										sparklers, or flammable items of any
										kind)
									</p>
								</li>
								<li>
									<p>Live animals of any kind</p>
								</li>
								<li>
									<p>Toxic substances (e.g., poisons)</p>
								</li>
								<li>
									<p>Gases or radioactive material</p>
								</li>
								<li>
									<p>
										Bones or ivory from any animal species
										that produce ivory (e.g., tusks, elk
										ivory, fossilized ivory, etc.)
									</p>
								</li>
								<li>
									<p>
										Products created using materials or
										parts that derive from any animal
										species designated “threatened or
										endangered” by the US Endangered Species
										Act, or listed in Appendix I of the
										Convention on International Trade in
										Endangered Species (CITES). ( Click here
										to read more about this).
									</p>
								</li>
								<li>
									<p>Product Humans</p>
								</li>
								<li>
									<p>
										Even though The Etho may suspend or
										terminate your account for any
										violations of these policies, you will
										still owe any outstanding fees on your
										The Etho bill
									</p>
								</li>
							</ol>
						</li>
					</ol>
					<h3 className=''>
						Displaying your Fair Trade certification(s):
					</h3>
					<p>
						Your shop’s Fair Trade certifications –– regardless of
						which The Etho-approved international or regional
						labeling organization has issued them to you –– must be
						displayed on your shop’s homepage (if we have verified
						that its standards align with our own). The easiest way
						to do this is to attain the approval label, symbol,
						icon, or logo associated with your certifier in a format
						that can be easily displayed on your shop pages. The
						Etho will help sellers display this label if you have
						issues finding a high quality digital version of your
						certification’s graphic/logo. Typically, these labels
						are properly sized and placed on a shop’s pages for easy
						viewing, similar to the examples below:
					</p>
					<div className='col-12 text-center'>
						<img src={FairTradeLogos} alt='Fair Trade Logos' />
					</div>
					<p>
						If your shop has not attained Fair Trade certification
						from one of our accepted labeling organizations –– and
						The Etho is able to verify that the materials and
						production conditions of your products meet our
						standards –– you will use one of The Etho’s
						certification labels in your shop, depending on the type
						of company or organization you are (not-for-profits have
						a distinct The Etho label).
					</p>
					<h3 className=''>
						Displaying Fair Trade information for customers in your
						shop:
					</h3>
					<p>
						As a rule, sellers should briefly list where your
						products’ materials comes from –– both on an individual
						item’s page, and on your shop’s homepage (even if
						materials are sourced from multiple places). We
						understand that not every seller has their own website
						with this information –– including your community’s
						story –– readily available to direct customers to from
						The Etho’s marketplace.
					</p>
					<p>
						So, concisely detailing how your Fair Trade practices
						meet The Etho’s ethical guidelines on your shop’s
						homepage or on an item’s page is important. And because
						transparency is so important to us and to The Etho
						customers, we encourage you to be as specific as
						possible about where and how your products were made,
						and where your materials come from.
					</p>
					<h3 className=''>Accuracy in your The Etho shop:</h3>
					<p>
						Honesty between buyers and sellers is a cornerstone of
						The Etho’s marketplace. Not only because of its role in
						the preservation of the transparent Fair Trade practices
						we promote, but also because honesty is crucial to the
						way The Etho works as an online marketplace.
					</p>
					<ol>
						<li>
							<p>
								Honest and accurate display and representation
								of your shop’s items, and of your organization
								or business, are requirements for selling on The
								Etho
							</p>
						</li>
						<li>
							<p>
								A product is not “honestly and accurately
								represented” if it is physically different from
								its listing description or the associated
								photographs. Common examples of inaccurate
								representation include orders where:
							</p>
							<ol>
								<li>
									<p>
										The item has a different design or
										material than its listing.
									</p>
								</li>
								<li>
									<p>
										The item was advertised as one kind of
										product, but is another kind altogether.
									</p>
								</li>
								<li>
									<p>
										The item received is a different color,
										model, version, or size than the one
										shown in the listing’s images or
										description.
									</p>
								</li>
								<li>
									<p>
										A customer purchased multiple items but
										received the incorrect number (e.g., a
										customer orders five items but only
										received three of them).
									</p>
								</li>
							</ol>
						</li>
						<li>
							<p>
								Your shop’s policies on shipping procedures,
								processing times, discounts, cancellations and
								all other customer experience-related
								information should be clearly displayed in your
								shop’s homepage, and referenced on an individual
								item’s page
							</p>
							<ol>
								<li>
									<p>Processing Time</p>
								</li>
							</ol>
						</li>
					</ol>
					<h3 className=''>Content in your The Etho Shop:</h3>
					<p>
						As a seller on The Etho, you can cultivate all kinds of
						content, both for your customer’s ease of use, and to
						make your The Etho shop attractive, interesting and
						unique. Between videos, pictures, messages, marketing or
						product information, and your item listings, your shop
						can look and sound exactly like you want it to. However,
						it is important to note that in order to ensure that our
						marketplace stays respectful and safe for all users,
						sellers are prohibited from uploading content that is:
					</p>
					<ol>
						<li>
							<p>
								In violation of a user's privacy or intellectual
								property rights
							</p>
						</li>
						<li>
							<p>Misleading or dishonest</p>
						</li>
						<li>
							<p>
								Coercive, defamatory, abusive, threatening,
								harassing, or otherwise in violation of The
								Etho's Anti Discrimination Policy
							</p>
						</li>
						<li>
							<p>
								Verbally or visually inappropriate, obscene or
								vulgar
							</p>
						</li>
						<li>
							<p>
								In violation of The Etho's User Privacy &amp;
								Online Communications Policy
							</p>
						</li>
					</ol>
					<h3 className=''>Shop Policies:</h3>
					<p>
						Your shop’s homepage should display policies and
						procedures that you, as the shop owner, have created for
						the benefit and protection of your shop and The Etho
						customers. These policies don't need to be lengthy, but
						should be detailed and clear enough that customers can
						easily understand your shop's shipping procedures,
						costs, processing times, the use of shop discounts,
						procedures for returns or cancellations, and all other
						customer experience-related information The Etho users
						may need. These policies will also be relevant should a
						dispute between you and a customer arise. They should be
						clearly displayed in your shop’s homepage, and
						referenced on an individual item’s page. At a minimum,
						your shop's policies need to clearly establish how your
						shop handles:
					</p>
					<ol>
						<li>
							<p>Payment processing</p>
						</li>
						<li>
							<p>
								Shipping (including estimated processing times)
							</p>
						</li>
						<li>
							<p>Common FAQ's about your shop or your products</p>
						</li>
						<li>
							<p>Refund</p>
						</li>
					</ol>
					<h3 className=''>Shop Reviews on The Etho:</h3>
					<p>
						Customer reviews are an easy and effective way to
						cultivate an awesome reputation on The Etho. Within 90
						days after an item’s date of delivery, buyers in The
						Etho marketplace can leave a review of your
						shop/products, a picture of their purchased item and a
						star-rating choice (five stars being the highest
						possible rating). On the rare occasion that you receive
						an unfavorable review, you can reach out to the
						customer, or, if the review is less than 3 stars, leave
						a written response. Customer reviews and/or your
						responses to customer reviews may not contain:
					</p>
					<ol>
						<li>
							<p>Advertising or spam</p>
						</li>
						<li>
							<p>
								Private customer or customer-related information
							</p>
						</li>
						<li>
							<p>
								Harassing, vulgar or inappropriate language or
								visuals of any kind
							</p>
						</li>
						<li>
							<p>
								Content that violates The Etho's
								Anti-Discrimination Policy
							</p>
						</li>
						<li>
							<p>
								Comments that are unrelated to the sellers'
								shop; topics outside of the seller's control
								(e.g., The Etho policies or actions, shipping
								providers, any third party, etc.)
							</p>
						</li>
						<li>
							<p>
								Comments or information that compromises the
								integrity of The Etho's review process
							</p>
						</li>
					</ol>
					<h3 className=''>Extortion &amp; Shilling Policy:</h3>
					<p>
						Extortion is when a seller offers one or more customers
						extra goods, services, or compensation of any kind in
						exchange for favorable reviews. Shilling is the
						promotion and praising of a shop through the use of an
						alternative account designed to inflate shop reputation
						fraudulently. Some people online use shilling to make a
						seller look more attractive to customers by increasing
						the seller’s sales or overall ratings. Customer reviews
						should reflect the honest opinions and/or experiences of
						the buyer. Extortion and shilling are both strictly
						prohibited on The Etho. Any attempt to produce or
						solicit fraudulent reviews or promotion through shilling
						or extortion is not allowed in our marketplace, and will
						result, at minimum, in the immediate loss of your The
						Etho user privileges.
					</p>
					<h3 className=''>Exchanges, Cancellations &amp; Returns</h3>
					<p>
						Please be aware that in addition to our policy here,
						each country usually has its own unique laws relating to
						product shipping, exchanges, cancellations, and returns.
						We strongly encourage sellers to familiarize themselves
						with the relevant laws of their particular country or
						region, as well as with those of the country where your
						customer(s) live.
					</p>
					<ol>
						<li>
							<p>
								If you can't complete a transaction, you must
								notify the customer through your shops messaging
								tool, and cancel the transaction.
							</p>
						</li>
						<li>
							<p>
								A seller may cancel a transaction with a The
								Etho customer under the following conditions:
							</p>
							<ol>
								<li>
									<p>The customer did not pay</p>
								</li>
								<li>
									<p>
										Both you and the customer agree to
										cancel the transaction before the item
										is shipped, and before you have issued
										any refunds
									</p>
								</li>
								<li>
									<p>
										The customer did not receive the item(s)
										purchased in your shop, even after
										producing proof of item shipment, and
										you have issued a refund to the customer
									</p>
								</li>
							</ol>
						</li>
						<li>
							<p>Can't Complete Transaction</p>
							<ol>
								<li>
									<p>Can't Complete Transaction Agreement</p>
								</li>
							</ol>
						</li>
					</ol>
					<h3 className=''>The Etho's Dispute Resolution Process:</h3>
					<p>
						In the event that a dispute arises between a seller and
						a customer about a purchase (or other product-related
						issue), we ask that buyers contact the seller directly
						and attempt to resolve any outstanding issues before
						initiating a dispute claim with The Etho. For this
						reason, and though it is unlikely that disputes with
						your shop will arise often, it is important that you
						display your shop's specific policies for buyers
						clearly, and that you regularly respond to messages from
						your customers. Customers may file a dispute claim with
						The Etho for two reasons: 1) a purchased item is not
						delivered, and 2) a purchased item is misrepresented in
						its seller's shop. As a seller, you must respond to any
						claims that The Etho receives––which we will work with
						you to resolve––within one week (seven days) of the
						claim's initiation by your customer. Dispute claims may
						be filed under the following circumstances:
					</p>
					<ol>
						<li>
							<p>Purchased item(s) not delivered:</p>
							<ol>
								<li>
									<p>
										This kind of claim occurs when a
										customer places an order for one or more
										items in your shop, submits payment
										successfully, but does not receive the
										item purchase. Often, a non-delivered
										purchase happens for these reasons:
									</p>
									<ol>
										<li>
											<p>
												A purchased product was never
												sent by the seller.
											</p>
										</li>
										<li>
											<p>
												A purchased product was not sent
												to the correct address provided
												by the customer
											</p>
										</li>
										<li>
											<p>
												The seller never received
												confirmation when they shipped
												the item and then the item was
												lost in transit.
											</p>
										</li>
									</ol>
								</li>
							</ol>
						</li>
						<li>
							<p>Purhcased items is misrepresented in a shop:</p>
							<ol>
								<li>
									<p>
										This kind of claim occurs when a
										customer places an order for one or more
										items in your shop, submits payment
										successfully, but receives an item
										qualitatively different from what they
										ordered. Often, an item
										mistrepresentation happens for this
										reason:
									</p>
									<ol>
										<li>
											<p>
												A purchased product was sorted
												incorrectly and mistakenly
												packaged and shipped in place of
												the item actually ordered by a
												customer.
											</p>
										</li>
									</ol>
								</li>
							</ol>
						</li>
					</ol>
					<h3 className=''>
						To sum up, by selling on The Etho you are agreeing to do
						the following:
					</h3>
					<ol>
						<li>
							<p>
								Display accurate information in your shop about
								your items, your company or organization, your
								Fair Trade practices, your policies, and your
								shop's story
							</p>
						</li>
						<li>
							<p>
								Respect the intellectual property rights of
								other The Etho users, and, if you feel that
								someone has violated your intellectual property
								rights, report it to us immediately.
							</p>
						</li>
						<li>
							<p>
								Accurately list your products using high quality
								images. (Again, if you don't have the ability to
								take high quality photos of your products, we
								can arrange someone to do it for you).
							</p>
						</li>
						<li>
							<p>
								Display your Fair Trade verification stamp
								and/or certified label(s) clearly on your shop's
								pages.
							</p>
						</li>
						<li>
							<p>
								Honor your own Shop's policies,
								includingshipping and processing times, item
								discounts, customer communications, etc.
								(Sellers should also aware that legal
								requirements for shipping times might vary by
								country).
							</p>
						</li>
						<li>
							<p>
								Avoid the use of misleadin, dishonest, coercive,
								defamatory, abusive, threatening, or harassing
								language or images, or any communications with
								other The Etho users that otherwise violate our
								Anti-Discrimination Policy and Terms of Use
							</p>
						</li>
						<li>
							<p>
								Provide a high level of customer service at all
								times, especially when problems arise with
								customers (e.g., during a dispute resolution
								process with a customer).
							</p>
						</li>
						<li>
							<p>
								Respond to messages from customers and other The
								Etho users in a timely manner.
							</p>
						</li>
						<li>
							<p>
								Avoid coordinating or controlling item prices
								with other sellers in any manner.
							</p>
						</li>
						<li>
							<p>
								Avoid creating replicate shops, or helping
								another shop owner to operate a duplicate shop
								of their own.
							</p>
						</li>
						<li>
							<p>
								Address and attempt to resolve disputes with
								customers directly before approaching The Etho
								for intervention.
							</p>
						</li>
						<li>
							<p>
								If you are unable to complete an order, you must
								notify the customer and cancel their order
								according to your shop's policies and our Terms
								of Use
							</p>
						</li>
					</ol>
				</div>
			</Section>
		</div>
	)
}

export default SellerExpectations
